import { Container } from "react-bootstrap";
import PageTitle from '../common/PageTitleBanner';

const Clients = () => {
    return (
        <>
            <PageTitle subtitle="Clients" title="Who we work with" bannerImage="assets/images/banner.jpg" />
            <section className="content-section lightbg">
                <Container>
                    <div className="row">
                        <div className="col-lg-8 offset-lg-2">
                            <div className="heading heading-md text-center mb-3"> title goes here!</div>
                            <div className="para-txt txt-large text-center mb-5">
                                <p>
                                    In publishing and graphic design, Lorem ipsum is a placeholder text commonly used to demonstrate the visual form of a document or a typeface without
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className="clients-container d-flex justify-content-center flex-wrap">
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client1.png" alt="" height="80px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client2.png" alt="" height="80px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client3.png" alt="" height="80px" />
                        </div>
                        <div className="client-block p-5">
                            <img src="assets/images/clients/client4.webp" alt="" height="80px" />
                        </div>
                    </div>
                </Container>
            </section>
        </>
    )
}
export default Clients;